import AxiosService from 'plugins/TS-lib-utils-public/services/AxiosService';

class LogsService extends AxiosService {
  constructor() {
    super('log');
  }

  getLogs = async (page, limit, filters = {}) => {
    const queryParams = new URLSearchParams({ page, limit });
    if (filters.type) queryParams.append('type', filters.type);
    if (filters.user) queryParams.append('user', filters.user);
    if (filters.severity) queryParams.append('severity', filters.severity);
    if (filters.module) queryParams.append('module', filters.module);
    if (filters.message) queryParams.append('message', filters.message);
    if (filters.dateFrom) queryParams.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) queryParams.append('dateTo', filters.dateTo);

    const response = await this.get(`/get-all/?${queryParams.toString()}`, {
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
    return response;
  };
}

export default new LogsService();